import { AppShell } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { HeaderMegaMenu } from "@/features/dashboard/_components/Header";

export const Route = createFileRoute("/_private/dashboard/_base")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <>
      <AppShell.Header>
        <HeaderMegaMenu />
      </AppShell.Header>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </>
  );
}
